import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../lib/api";
import DocumentsList from "../components/DocumentsList";
import { SITE_DOC_CATEGORIES, fmtDate } from "../lib/utils-app";
import { ArrowLeft, HardHat } from "lucide-react";

export default function SiteDetail() {
  const { id } = useParams();
  const [s, setS] = useState(null);
  const [company, setCompany] = useState(null);

  useEffect(() => {
    (async () => {
      const { data } = await api.get(`/sites/${id}`);
      setS(data);
      const c = await api.get(`/companies/${data.company_id}`);
      setCompany(c.data);
    })();
  }, [id]);

  if (!s) return <div className="text-slate-500">Caricamento…</div>;

  const stateCls = s.stato === "attivo" ? "status-valid" : s.stato === "sospeso" ? "status-expiring" : "status-expired";

  return (
    <div className="space-y-6">
      <Link to={`/aziende/${s.company_id}`} className="inline-flex items-center gap-1 text-sm text-slate-500 hover:text-slate-900">
        <ArrowLeft size={14} /> {company?.ragione_sociale || "Azienda"}
      </Link>

      <header className="bg-white border border-slate-200 rounded-lg p-6 flex flex-wrap items-start gap-4 justify-between">
        <div className="flex items-start gap-4">
          <div className="w-14 h-14 rounded-lg bg-blue-50 text-blue-800 flex items-center justify-center"><HardHat size={26} /></div>
          <div>
            <div className="text-xs font-mono uppercase tracking-widest text-blue-700 mb-1">Cantiere</div>
            <h1 className="font-display text-2xl font-bold text-slate-900">{s.denominazione}</h1>
            <div className="text-sm text-slate-500 mt-1">{s.indirizzo || "—"}</div>
          </div>
        </div>
        <span className={`status-pill ${stateCls}`}>Stato: {s.stato}</span>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Info label="Committente" v={s.committente} />
        <Info label="Data inizio" v={fmtDate(s.data_inizio)} />
        <Info label="Fine prevista" v={fmtDate(s.data_fine_prevista)} />
        <Info label="Responsabile Lavori" v={s.responsabile_lavori} />
        <Info label="CSP" v={s.csp} />
        <Info label="CSE" v={s.cse} />
        <div className="md:col-span-3">
          <Info label="Descrizione lavori" v={s.descrizione_lavori} />
        </div>
      </div>

      <section>
        <h2 className="font-display font-semibold text-slate-900 mb-3">Documenti cantiere</h2>
        <DocumentsList entityType="site" entityId={s.id} companyId={s.company_id} categories={SITE_DOC_CATEGORIES} />
      </section>
    </div>
  );
}

function Info({ label, v }) {
  return (
    <div className="bg-white border border-slate-200 rounded-lg p-4">
      <div className="text-xs uppercase tracking-wider text-slate-500 font-mono">{label}</div>
      <div className="mt-1 text-slate-900">{v || "—"}</div>
    </div>
  );
}
